import React, { useState } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '../context/AuthContext';
import { ROLES } from '../data/roles';

const Layout = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  // Safeguard: Prevent render crash if currentUser hasn't synced fully yet
  if (!currentUser) return null;

  if (currentUser.role === ROLES.EMPLOYEE && location.pathname === '/') {
    return <Navigate to="/employee/dashboard" replace />;
  }
  if (currentUser.role === ROLES.MANAGER && location.pathname === '/') {
    return <Navigate to="/my-team" replace />;
  }

  return (
    <div className="flex min-h-screen bg-slate-50 pb-16 md:pb-0">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-200 ${collapsed ? 'md:ml-16' : 'md:ml-64'}`}>
        <Header />
        <main className="flex-1 p-4 md:p-8 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;